import { render, staticRenderFns } from "./RouterChat.vue?vue&type=template&id=4a5b536e&"
import script from "./RouterChat.vue?vue&type=script&lang=js&"
export * from "./RouterChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports